import {発注履歴照会依頼型} from '@/type/purchaseorder/history';
import {定点発注条件設定取込不可一覧型, 定点発注条件設定取得依頼型} from '@/type/automatedorder/item';
import {発注書出力条件型, 発注確認書出力条件型} from '@/type/purchaseorder/report';
import {棚卸表出力条件型} from '@/type/stocktaking/report';
import {入庫履歴照会依頼型} from '@/type/stock/receive/hisotry';
import {譲受履歴検索条件型} from '@/type/stock/inherit/history/item';
import {譲渡履歴検索条件型} from '@/type/stock/devolve/history/item';
import {返品履歴照会依頼型} from '@/type/stock/returns/hisotry';
import {譲渡書出力依頼型} from '@/type/stock/devolve/input/item';
import {採用品検索条件型} from '@/type/master/item';
import {商品別連携設定検索条件型, 商品別連携設定一括登録結果型} from '@/type/master/item/external';
import {納品データ検索依頼型} from '@/type/stock/deliverydata/unstocked_deliverydata';
import {入庫返品薬価差集計依頼型} from '@/type/stock/receive/price_diff';
import {適用価格検索依頼型} from '@/type/item/price';
import {卸別入出庫集計依頼型, 品目別入出庫表示依頼型} from '@/type/stock/summary/receive_delivery_summary';
import { 不動在庫検索依頼型 } from '@/type/inactive/stock';
import {商品台帳一覧表取得依頼型} from '@/type/stock/itemledger/types';
import {マニュアル型} from '@/type/manual/manual';
import {優先卸検索依頼型} from '@/type/wholesale/primary/wholesale';
import {入出庫照会絞込条件型} from '@/type/stock/receiveandreturns/types';
import {払出履歴検索条件型} from '@/type/withdrawal/records/history/払出履歴検索条件型';
import {不動日数設定出力依頼型, 不動日数設定検索依頼型} from '@/type/stock/immovable/不動日数設定';
import {棚番設定表示条件型} from '@/type/shelf/settings';
import {入札出力依頼型} from '@/type/estimates/bid';
import {渓仁会納品データ検索依頼型} from '@/type/custom/keijinkai/deliverydata';
import {渓仁会部署別在庫集計検索依頼型} from '@/type/custom/keijinkai/totalstock';
import {渓仁会入出庫集計検索依頼型} from '@/type/custom/keijinkai/receiveandreturns';
import {渓仁会部署別出庫実績集計検索依頼型} from '@/type/custom/keijinkai/shipment';
import {
  日付別発注実績明細表出力条件型,
  納入実績明細表出力条件型,
  納入実績集計表出力条件型,
  出庫実績集計表出力条件型,
  薬品別受払年報出力条件型,
  メーカー別受入分析表出力条件型,
  薬品別受入分析表出力条件型,
} from '@/type/custom/otaru/report/report';

import Auth from '@/infrastructure/api/helper/Auth';
import {定数在庫表出力依頼型} from '@/type/custom/goryoukaku/定数在庫表出力依頼型';
import {トーショー納入明細出力条件型} from '@/type/custom/otaru/tosho/recievedetail';
import {薬品受払表出力依頼型} from '@/type/custom/goryoukaku/薬品受払表出力依頼型';
import {カスタマイズ棚番設定表示条件型} from '@/type/custom/goryoukaku/棚番設定';
import {期限切れ破棄破損検索条件型} from '@/type/custom/otaru/destroy/otaruDestroyListSearchCriteria';

import {
  新さっぽろ脳神経外科病院メーカー別集計表出力条件型,
  新さっぽろ脳神経外科病院購入順位表出力条件型,
  新さっぽろ脳神経外科病院払出薬価順位表出力条件型,
  新さっぽろ脳神経外科病院払出集計表出力条件型,
  新さっぽろ脳神経外科病院受払一覧表出力条件型,
} from '@/type/custom/shinsapporo/report/report';

export default {

  async 在庫一覧表を出力する(path: string, filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/refstock/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 棚卸差数一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/inquire/inventory_diff/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 棚卸一覧表を出力する(filename: string, 棚卸一覧出力依頼: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stocktaking/download/excel', 棚卸一覧出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 入札出力(filename: string, 入札出力依頼: 入札出力依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/bid/download', 入札出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 卸配布用入札出力(filename: string, 入札出力依頼: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/wholesale/bid/export', 入札出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 表示内容入札表出力(filename: string, 表示内容入札表出力依頼: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/export', 表示内容入札表出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 定点発注条件設定一覧表を出力する(filename: string, 定点発注条件設定取得依頼: 定点発注条件設定取得依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/purchaseorder/demand/export', 定点発注条件設定取得依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 定点発注条件設定取込不可一覧表を出力する(filename: string, 定点発注条件設定取込不可一覧: 定点発注条件設定取込不可一覧型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/purchaseorder/demand/unavailable', 定点発注条件設定取込不可一覧, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 発注履歴照会一覧表を出力する(filename: string, 発注履歴照会依頼: 発注履歴照会依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/purchaseorder/history/download', 発注履歴照会依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async バーコードブックExcelを出力する(filename: string): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/barcodebook/export', {}, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 払出履歴照会一覧表を出力する(filename: string, 検索内容: 払出履歴検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/withdrawal/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 破棄破損履歴照会一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/destroy/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 入庫履歴照会一覧表を出力する(filename: string, 入庫履歴照会依頼: 入庫履歴照会依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/receive/history/download', 入庫履歴照会依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 譲受履歴照会一覧表を出力する(filename: string, 直近譲受履歴検索条件: 譲受履歴検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/inherit/history/download', 直近譲受履歴検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 譲渡履歴照会一覧表を出力する(filename: string, 直近譲渡履歴検索条件: 譲渡履歴検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/history/download', 直近譲渡履歴検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 返品履歴照会一覧表を出力する(filename: string, 返品履歴照会依頼: 返品履歴照会依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/returns/history/download', 返品履歴照会依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 採用品一覧表を出力する(filename: string, 採用品検索条件: 採用品検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/item/list/download', 採用品検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 採用品一括登録用一覧表を出力する(filename: string, 採用品検索条件: 採用品検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/item/bulkregister/download', 採用品検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 商品別連携設定一括登録用一覧表を出力する(filename: string, 商品別連携設定検索条件: 商品別連携設定検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/item/external/bulkregister/download',
                                        商品別連携設定検索条件, { responseType: 'blob' });
    const file = response.data;
    this.excelout(file, filename);
  },

  async 商品別連携設定一括登録エラー一覧表を出力する(filename: string, 商品別連携設定一括登録結果: 商品別連携設定一括登録結果型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/item/external/bulkregister/errors',
                                        商品別連携設定一括登録結果, { responseType: 'blob' });
    const file = response.data;
    this.excelout(file, filename);
  },

  async 納品データ未入庫照会一覧表を出力する(filename: string, 納品データ検索依頼: 納品データ検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/unstocked/download', 納品データ検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 入庫返品薬価差照会一覧表を出力する(filename: string, 入庫返品薬価差集計依頼: 入庫返品薬価差集計依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/price_diff/download', 入庫返品薬価差集計依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 卸別入出庫一覧表を出力する(filename: string, 卸別入出庫集計依頼: 卸別入出庫集計依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/summary/receive_delivery/download',
      卸別入出庫集計依頼,
      {responseType: 'blob'},
    );
    const file = response.data;
    this.excelout(file, filename);
  },

  async 品目別入出庫一覧表を出力する(filename: string, 品目別入出庫表示依頼: 品目別入出庫表示依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/summary/receive_delivery_item/download',
      品目別入出庫表示依頼,
      {responseType: 'blob'},
    );
    const file = response.data;
    this.excelout(file, filename);
  },

  async 品目別明細入出庫一覧表を出力する(filename: string, 品目別入出庫表示依頼: 品目別入出庫表示依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/summary/receive_delivery_detail/download',
      品目別入出庫表示依頼,
      {responseType: 'blob'},
    );
    const file = response.data;
    this.excelout(file, filename);
  },

  async 不動在庫照会一覧表を出力する(filename: string, 不動在庫検索依頼: 不動在庫検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/inactive/stock/download',
      不動在庫検索依頼,
      {responseType: 'blob'},
    );
    const file = response.data;
    this.excelout(file, filename);
  },

  async 棚番設定一覧表を出力する(filename: string, 棚番設定表示条件: 棚番設定表示条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/shelf/export', 棚番設定表示条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  excelout(data: Blob, filename: string): void {
    const url = URL.createObjectURL(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
  },

  async 発注書帳票を出力する(filename: string, 帳票内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/purchaseorder', 帳票内容, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 発注書帳票を表示する(帳票内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/purchaseorder', 帳票内容, {responseType: 'blob'});
    const file = response.data;
    this.pdfshow(file);
  },

  async 対象の発注書帳票を出力する(filename: string, 発注書出力条件: 発注書出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/purchaseorder', 発注書出力条件, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 対象の発注確認書帳票を出力する(filename: string, 発注確認書出力条件: 発注確認書出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/orderconfirmation', 発注確認書出力条件, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async バーコードブック帳票を出力する(filename: string, 帳票内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/barcodebook/print', 帳票内容, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 移動履歴一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/movement/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 棚卸表帳票を出力する(filename: string, 棚卸表出力条件: 棚卸表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/stocklist', 棚卸表出力条件, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 譲渡書を出力する(filename: string, 譲渡書出力依頼: 譲渡書出力依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/form/export', 譲渡書出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 適用価格取込Excelを出力する(filename: string, 適用価格検索依頼: 適用価格検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/item/price/import/download', 適用価格検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 優先卸取込Excelを出力する(filename: string, 優先卸検索依頼: 優先卸検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/wholesale/primary/import/download', 優先卸検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 商品台帳一覧表を出力する(filename: string, 商品台帳一覧表取得依頼: 商品台帳一覧表取得依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/itemledger/download/excel', 商品台帳一覧表取得依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 院内総在庫一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/inhospital/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 経過措置在庫一覧表を出力する(filename: string, 検索内容: {}): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/interim/download/excel', 検索内容, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 入出庫集計一覧を出力する(filename: string, 入出庫照会絞込条件: 入出庫照会絞込条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/receiveandreturns/download/excel', 入出庫照会絞込条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 不動日数設定取込Excelを出力する(filename: string, 不動日数設定検索依頼: 不動日数設定検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/immovable/download/import', 不動日数設定検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 不動日数設定一覧をExcel出力する(filename: string, 不動日数設定出力依頼: 不動日数設定出力依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/immovable/download/errors', 不動日数設定出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 渓仁会部署別在庫集計をExcel出力する(filename: string, 検索依頼: 渓仁会部署別在庫集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/total/download', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 渓仁会部署別在庫集計をPDF出力する(filename: string, 検索依頼: 渓仁会部署別在庫集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/total/pdf', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 渓仁会入出庫集計をExcel出力する(filename: string, 検索依頼: 渓仁会入出庫集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/receiveandreturns/download', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 渓仁会入出庫集計表をPDF出力する(filename: string, 検索依頼: 渓仁会入出庫集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/receiveandreturns/pdf', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  async 渓仁会部署別出庫実績集計をExcel出力する(filename: string, 検索依頼: 渓仁会部署別出庫実績集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/shipment/download', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 渓仁会部署別出庫実績集計をPDF出力する(filename: string, 検索依頼: 渓仁会部署別出庫実績集計検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/shipment/pdf', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.pdfout(file, filename);
  },

  pdfout(data: any, filename: string): void {
    const url = URL.createObjectURL(new Blob([data], {type: 'application/pdf'}));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
  },

  pdfshow(data: any): void {
    const url = URL.createObjectURL(new Blob([data], {type: 'application/pdf'}));
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
  },

  async マニュアルファイルをダウンロードする(filename: string, マニュアル: マニュアル型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/manual/file/download', マニュアル, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 渓仁会納品データを出力する(filename: string, 検索依頼: 渓仁会納品データ検索依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/deliverydata/download', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 日付別発注実績明細表を出力する(filename: string, 検索依頼: 日付別発注実績明細表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/dailyorderdetail', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 納入実績明細表を出力する(filename: string, 検索依頼: 納入実績明細表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/deliveryresultdetail', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 納入実績集計表を出力する(filename: string, 検索依頼: 納入実績集計表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/delivery-result-aggregate', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 出庫実績集計表を出力する(filename: string, 検索依頼: 出庫実績集計表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/shipment-aggregate', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 薬品別受払年報を出力する(filename: string, 検索依頼: 薬品別受払年報出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/medicineinventoryreport', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async メーカー別受入分析表を出力する(filename: string, 検索依頼: メーカー別受入分析表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/recieve/maker', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 薬品別受入分析表JANを出力する(filename: string, 検索依頼: 薬品別受入分析表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/recieve/medichine/jan', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 薬品別受入分析表厚生省を出力する(filename: string, 検索依頼: 薬品別受入分析表出力条件型): Promise<void> {
    const auth = new Auth();
    const response =
      await auth.post('/api/otaru/report/recieve/medichine/welfare', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 薬品別受入分析表実績なしを出力する(filename: string, 検索依頼: 薬品別受入分析表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/report/recieve/medichine/norecord', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async トーショー納入明細CSVを出力する(filename: string, 検索依頼: トーショー納入明細出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/otaru/tosho/recieve/detail/download', 検索依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 五稜郭病院定数在庫表を出力する(filename: string, 定数在庫表出力依頼: 定数在庫表出力依頼型): Promise<void> {
    const auth = new Auth();
    const response =
      await auth.post('/api/custom/goryoukaku/constantstock/download', 定数在庫表出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async 五稜郭病院薬品受払表を出力する(filename: string, 薬品受払表出力依頼: 薬品受払表出力依頼型): Promise<void> {
    const auth = new Auth();
    const response =
      await auth.post('/api/custom/goryoukaku/balance/download', 薬品受払表出力依頼, {responseType: 'blob'});
    const file = response.data;
    this.fileout(file, filename);
  },

  async カスタマイズ棚番設定一覧表を出力する(filename: string, 棚番設定表示条件: カスタマイズ棚番設定表示条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/goryoukaku/shelf/export', 棚番設定表示条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 小樽市立期限切れ破棄破損一覧を出力する(filename: string, 検索条件: 期限切れ破棄破損検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/otaru/destroy/download/excel', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 新さっぽろ脳神経外科病院メーカー別集計表を出力する(filename: string, 検索条件: 新さっぽろ脳神経外科病院メーカー別集計表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/shinsapporo/report/maker-sumary', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 新さっぽろ脳神経外科病院購入順位表を出力する(filename: string, 検索条件: 新さっぽろ脳神経外科病院購入順位表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/shinsapporo/report/buy-rank', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 新さっぽろ脳神経外科病院払出薬価順位表を出力する(filename: string, 検索条件: 新さっぽろ脳神経外科病院払出薬価順位表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/shinsapporo/report/drugprice-rank', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 新さっぽろ脳神経外科病院払出集計表を出力する(filename: string, 検索条件: 新さっぽろ脳神経外科病院払出集計表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/shinsapporo/report/payout-sumary', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  async 新さっぽろ脳神経外科病院受払一覧表を出力する(filename: string, 検索条件: 新さっぽろ脳神経外科病院受払一覧表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/shinsapporo/report/balance-list', 検索条件, {responseType: 'blob'});
    const file = response.data;
    this.excelout(file, filename);
  },

  fileout(data: any, filename: string): void {
    const url = URL.createObjectURL(new Blob([data], {type: 'application/octet-stream'}));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
  },
};
